<template>
  <b-nav-item class="link-to-tour" to="/en/places/this-is-place">
    <div class="worldCard">
      <div class="fillter"></div>
        <figure>
          <img src="images/homepage/bali.jpg" alt="Maltese Terrier">
          <b-col class="caption-container">
            <figcaption class="figcaption">
              بالي
            </figcaption>
          </b-col>
        </figure>
    </div>
  </b-nav-item>
</template>
<script type="text/javascript">

  export default {
    name:'WorldTourCard',
    components: {
    }
  }
</script>
